<template>
  <div>
    <div style="margin-top: 10px">
      <h3>项目基本资料</h3>
      <div class="info-item">
        <span>项目名称：{{ projectData.projectName }}</span>
      </div>
      <div class="info-item">
        <span>项目编号全称：{{ projectData.projectFull }}</span>
      </div>
      <div class="info-item">
        <span>项目简称：{{ projectData.projectShort }}</span>
      </div>
      <div class="info-item">
        <span>所属部门：{{ projectData.district }}</span>
      </div>
      <div class="info-item">
        <span>所属地区：{{ projectData.area }}</span>
      </div>
      <div class="info-item">
        <span>当地编号：{{ projectData.localNumber }}</span>
      </div>
      <div class="info-item">
        <span>分子公司：{{ projectData.companyName }}</span>
      </div>
      <h3>项目采购类别及客户行业分类</h3>
      <div class="info-item">
        <span>招标平台：{{ projectData.bidPlatform }}</span>
      </div>
      <div class="info-item">
        <span>项目性质：{{ projectData.projectProperty }}</span>
      </div>
      <div class="info-item">
        <span>采购类别：{{ projectData.buyerNature }}</span>
      </div>
      <div class="info-item">
        <span>资金来源：{{ projectData.capitalSource }}</span>
      </div>
      <div class="info-item">
        <span>采购方式：{{ projectData.buyerModes }}</span>
      </div>
      <div class="info-item">
        <span>采购进出口：{{ projectData.import }}</span>
      </div>
      <div class="info-item">
        <span>是否有论证：{{ projectData.argument }}</span>
      </div>
      <div class="info-item">
        <span>包组数量：{{ projectData.groupCount }}</span>
      </div>
      <div class="info-item">
        <span>采购内容：{{ projectData.purchaseContent }}</span>
      </div>
      <h3>集团客户</h3>
      <div class="info-item">
        <span>集团客户：{{ projectData.specialCustomer }}</span>
      </div>
      <div class="info-item">
        <span>分支机构：{{ projectData.branchName }}</span>
      </div>
      <h3>项目预算及应收款</h3>
      <div class="info-item">
        <span>资格标预计：{{ projectData.qualifyPredict }}</span>
      </div>
      <div class="info-item">
        <span>预算金额(元)：{{ projectData.purchaseBudget }}</span>
      </div>
      <div class="info-item">
        <span>服务费类型：{{ projectData.serviceFeeType }}</span>
      </div>
      <div class="info-item">
        <span>预计服务费(元)：{{ projectData.servicePredict }}</span>
      </div>
      <div class="info-item">
        <span>应收服务费(元)：{{ projectData.receivables }}</span>
      </div>
      <div class="info-item">
        <span>中标金额：{{ projectData.winMoney }}</span>
      </div>
      <h3>采购人基本资料</h3>
      <div class="info-item">
        <span>采购人名称：{{ projectData.purchaserName }}</span>
      </div>
      <div class="info-item">
        <span>联系地址：{{ projectData.pAddress }}</span>
      </div>
      <div class="info-item">
        <span>联系方式：{{ projectData.pTel }}</span>
      </div>
      <div class="info-item">
        <span>采购联系人：{{ projectData.pContacts }}</span>
      </div>
      <div class="info-item">
        <span>采购人属性：{{ projectData.pAttr }}</span>
      </div>
      <div class="info-item">
        <span>客户所属行业：{{ projectData.clientSys }}</span>
      </div>
      <h3>业务基本信息</h3>
      <div class="info-item">
        <span>客户经理：{{ projectData.am }}</span>
      </div>
      <div class="info-item">
        <span>立项时间：{{ projectData.newProjectTime }}</span>
      </div>
      <div class="info-item">
        <span>备注：{{ projectData.comment }}</span>
      </div>
      <div class="info-item">
        <span>项目经理：{{ projectData.follower }}</span>
      </div>
      <div class="info-item">
        <span>项目状态：{{ projectData.projectState }}</span>
      </div>
      <div class="info-item">
        <span>项目助理：{{ projectData.aid }}</span>
      </div>
      <div class="info-item">
        <span>会务跟进人员：{{ projectData.merchandiser }}</span>
      </div>
      <div class="info-item">
        <span>委托协议签订状态：{{ projectData.entrustAgreementStatus }}</span>
      </div>
      <div class="info-item">
        <span>委托协议签订时间：{{ projectData.entrustAgreementTime }}</span>
      </div>
      <h3>相关公告信息</h3>
      <div class="info-item" v-for="article in articleList" :key="article.id">
        <span style="color:#2d8cf0;cursor:pointer" @click="articleCode(article.id)">{{ article.title }}</span>
      </div>
    </div>
    <Modal
      class="invite-modal"
      v-model="showCode"
      :mask-closable="false"
      :width="300"
      style="text-align:center"
      :transfer="false"
    >
      <div slot="header">扫码查看公告详情</div>
      <img :src="'data:image/png;base64,' + qrBase" style="width:200px">
      <p>官网公告详情链接：
        <a :href="articleUrl" target="blank">{{ articleUrl }}</a>
      </p>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
  props: {
    projectData: {
      type: Object
    }
  },
  data() {
    return {
      articleList: [],
      showCode: false,
      qrBase: '',
      articleId: ''
    }
  },
  computed: {
    articleUrl() {
      return `http://www.chinapsp.cn/wxNotice.html?itemid=${this.articleId}&timestamp=${new Date().getTime()}`
    }
  },
  watch: {
    async projectData() {
      // 获取公告列表
      let rep = await ajax.get(requestUrls.articles.getPaged, {
        params: {
          maxResultCount: 100,
          skipCount: 0,
          filter: `a.objectId=="${this.projectData.id}"`,
          sorting: 'a.creationTime desc'
        }
      })
      if (rep.data.success) {
        this.articleList = rep.data.result.items
      }
    }
  },
  methods: {
    articleCode(articleId) {
      this.$Spin.show()
      this.articleId = articleId
      ajax
        .post('https://api.choicelink.cn/UserCenter/api/TokenAuth/QRCode', {
          path: `pages/articlePage/articlePage?itemid=${articleId}`,
          authProvider: 'cailian'
        })
        .then((res) => {
          this.$Spin.hide()
          this.showCode = true
          this.qrBase = res.data.result
        })
    }
  }
}
</script>
<style lang="less" scoped>
.info-item {
  min-width: 250px;
  margin: 5px 20px;
  display: inline-block;
}
</style>
